// extracted by mini-css-extract-plugin
export var body = "_m0-0";
export var sectionHeader = "_m0-4";
export var shortcutColumns = "_m0-2";
export var shortcutList = "_m0-1";
export var shortcutSection = "_m0-3";